import React from 'react';
import './StudentLife.css';
import heroImg from '../assets/studentlife/hero.jpg';
import activity1 from '../assets/studentlife/activity1.jpg';
import activity2 from '../assets/studentlife/activity2.jpg';
import activity3 from '../assets/studentlife/activity3.jpg';
import gallery1 from '../assets/studentlife/gallery1.jpg';
import gallery2 from '../assets/studentlife/gallery2.jpg';
import gallery3 from '../assets/studentlife/gallery3.jpg';
import imgKindergarten from '../assets/studentlife/kindergarten.png';
import imgPrimary from '../assets/studentlife/primary.png';
import imgMiddle from '../assets/studentlife/middle.png';
import imgHigh from '../assets/studentlife/high.png';
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const StudentLife = () => {
  return (
    <div className="student-life-page">
	 
	  
	   <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   
      {/* Hero Section */}
      <section className="student-hero">
        <img src={heroImg} alt="Student Life at Universal Academy" />
        <div className="hero-text">
          <h1>Student Life at Universal Academy</h1>
          <p>Discover a vibrant campus filled with passion, purpose, and personal growth.</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="student-intro">
        <h2>Holistic Growth Through Activities</h2>
        <p>
          Universal Academy School is an environment that is bustling with activity, full of excitement, and overflowing with life. Students build friendships, learn responsibility and work hard in a safe, secure environment.  Be it singing, acting, competing, or learning, we are doing so in an unique way to create an education that defines a lifetime.  At Universal Academy, our students experience a holistic growth.  From awareness rallies, to participation in many events within the community, we believe in the importance of the entire student body being involved together and we ensure that our students learn moral values along with studies.
        </p>
      </section>

      {/* Highlights Section */}
      <section className="student-highlights">
        <div className="highlight-card">
          <img src={activity1} alt="Sports" />
          <h3>Sports & Fitness</h3>
          <p>From athletics to yoga, we nurture physical strength and discipline.</p>
        </div>
        <div className="highlight-card">
          <img src={activity2} alt="Clubs" />
          <h3>Clubs & Hobbies</h3>
          <p>Science, arts, reading, nature, and more — there’s a club for every passion.</p>
        </div>
        <div className="highlight-card">
          <img src={activity3} alt="Events" />
          <h3>Events & Competitions</h3>
          <p>Celebrations and challenges that inspire confidence and expression.</p>
        </div>
      </section>

      {/* Gallery */}
      <section className="student-gallery">
        <h2>Campus in Action</h2>
        <div className="gallery-grid">
          <img src={gallery1} alt="Campus event 1" />
          <img src={gallery2} alt="Campus event 2" />
          <img src={gallery3} alt="Campus event 3" />
        </div>
      </section>
	  
	  
	  <div className="student-life-modern">
      {/* Hero Section */}
     

      {/* Colored Sections */}
      <section className="student-block purple">
        <div className="text">
          <h2>KINDERGARTEN</h2>
          <p>
            At Universal Academy, Kindergarten  is a fun-filled program designed to enhance the development of the whole child. We have experienced, dedicated, and nurturing staff members to make preschool a rewarding experience for your child. Our Tiny Tots enjoy a Montessori based learning. 
          </p>
        </div>
        <div className="image">
          <img src={imgKindergarten} alt="Kindergarten" />
        </div>
      </section>

      <section className="student-block orange reverse">
        <div className="text">
          <h2>LOWER STANDARDS (I – V)</h2>
          <p>
            In addition to providing a solid academic environment, we believe that physical activity is an integral part of education. We at Universal Academy strongly believe that a sound mind and body is the key to a child’s success. 
Having a collaboration with Lead Pinnacle Groups – Premium Institute in India, At Universal Academy, we provide virtual smartboard classes for grades I to V.

          </p>
        </div>
        <div className="image">
          <img src={imgPrimary} alt="Lower Standards" />
        </div>
      </section>

      <section className="student-block teal">
        <div className="text">
          <h2>MIDDLE SCHOOL (VI – VIII)</h2>
          <p>
            The Middle School program is designed to meet the needs of the students as they become mature, independent workers and thinkers. Students are expected to be personally responsible in a framework that allows for intellectual curiosity and the development of positive moral and social values. Through various extra-curricular activities like Yoga, Karate, Archery, Dance, our students are allowed to grow and develop.

At Universal, we train the middle school students academically providing them a foundation to face all competitive exams like Olympiads.

          </p>
        </div>
        <div className="image">
          <img src={imgMiddle} alt="Middle School" />
        </div>
      </section>

      <section className="student-block green reverse">
        <div className="text">
          <h2>HIGHER SECONDARY (IX – XII)</h2>
          <p>
           The Middle School program is designed to meet the needs of the students as they become mature, independent workers and thinkers. Students are expected to be personally responsible in a framework that allows for intellectual curiosity and the development of positive moral and social values. Through various extra-curricular activities like Yoga, Karate, Archery, Dance, our students are allowed to grow and develop.

At Universal, we train the middle school students academically providing them a foundation to face all competitive exams like Olympiads.
It is with great pride, we announce that many our students are placed at top Engineering and Medical Colleges like NIT’s, VIT, JIPMER, Indira Gandhi Medical College to name a few. 
All of our students leave Universal Academy with the tools they need for successful college lives. 

          </p>
        </div>
        <div className="image">
          <img src={imgHigh} alt="Higher Secondary" />
        </div>
      </section>
    </div>
	
	<Footer />
    </div>
	
	
  );
};

export default StudentLife;
